var URLRequestMethod = (function () {
    function URLRequestMethod() {
    }
    return URLRequestMethod;
}());
export { URLRequestMethod };
/**
 *
 * @type {string}
 */
URLRequestMethod.POST = 'POST';
/**
 *
 * @type {string}
 */
URLRequestMethod.GET = 'GET';



// WEBPACK FOOTER //
// ../dist/lib/net/URLRequestMethod.js